// extracted by mini-css-extract-plugin
export default {"contents":"BF-z","sectionHeading":"CF-z"};